__turbopack_context__.v({
  "SAnswer": "Lu2WhG_SAnswer",
  "SAnswer_showing": "Lu2WhG_SAnswer_showing",
  "SQuestion": "Lu2WhG_SQuestion",
  "SQuestionContainer": "Lu2WhG_SQuestionContainer",
  "SQuestion_active": "Lu2WhG_SQuestion_active",
});
